import unionBy from 'lodash/unionBy';
import { IClientOption } from '~/store/client/types';
import { sortByFullName } from '~/ui/pages/Reports/helpers/sortByName';
import { IOption } from '~/types';

export default (clients: IClientOption[]): IOption[] => {
  const sortedClients = (clients || [])
    .sort((a, b) => sortByFullName(a, b, false))
    .map(item => ({ value: item.id, label: item.name }));

  return unionBy(sortedClients, 'value');
};
